
import Vue from 'vue';

export default Vue.extend({
    name: 'CustomSwitch',
    data: () => ({}),
    props: {
        value: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    },
    methods: {
        toggle() {
            this.$emit('input', !this.value);
            this.$emit('change');
        }
    },
})
